<template>
  <img :class="[doShowPreviewImage ? 'print-only' : 'd-none']" :src="previewImage + '/full/,' + height + '/0/default.jpg'" >
</template>

<script>
export default {
  props: {
    image: { type: String, required: true },
    height: { type: Number, required: false, default: 800 },
  },

  data() {
    return {
      previewImage: this.image,
      doShowPreviewImage: false
    }
  },

  created() {
    EventDispatcher.listen('showPreviewImage', (doShowPreviewImage) => {
      this.doShowPreviewImage = doShowPreviewImage;
    });

    EventDispatcher.listen('updatePreviewImage', (previewImage) => {
      this.previewImage = previewImage;
    });
  }
}
</script>

<style lang="scss" scoped>
  img.print-only {
    display: none;
  }

  @media print {
    img.print-only {
      max-width: 100%;
      display: block;
    }
  }
  
</style>